import { useState, useEffect } from "react";

const scenes = [
  { name: "Evening", levels: [0.9, 0.4, 0.2, 0.6, 0.1] },
  { name: "Focus", levels: [0.3, 0.9, 0.8, 0.2, 0.5] },
  { name: "Ambient", levels: [0.5, 0.5, 0.5, 0.5, 0.5] },
  { name: "Cinema", levels: [0.05, 0.05, 0.05, 0.1, 0.02] },
];

export function SystemColumn() {
  const [activeScene, setActiveScene] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveScene((s) => (s + 1) % scenes.length);
    }, 3500);
    return () => clearInterval(interval);
  }, []);

  const scene = scenes[activeScene];

  return (
    <div className="flex flex-col">
      {/* Column label */}
      <p className="font-sans text-[10px] font-medium uppercase tracking-[0.3em] text-[hsl(0,0%,40%)]">
        System
      </p>

      <div className="mt-8">
        <h3 className="font-sans text-lg font-light tracking-wide text-[hsl(0,0%,92%)]">
          LUTRON
        </h3>
        <p className="mt-1 font-sans text-xs text-[hsl(0,0%,50%)]">
          Scene-Based Lighting Control
        </p>
      </div>

      {/* Glowing panel UI */}
      <div className="mt-10 rounded-lg border border-[hsl(0,0%,12%)] bg-[hsl(0,0%,5%)] p-6">
        {/* Scene selector */}
        <div className="flex gap-3">
          {scenes.map((s, i) => (
            <button
              key={s.name}
              onClick={() => setActiveScene(i)}
              className={`font-sans text-[10px] uppercase tracking-[0.2em] transition-all duration-700 ${
                i === activeScene
                  ? "text-[hsl(40,30%,75%)]"
                  : "text-[hsl(0,0%,30%)] hover:text-[hsl(0,0%,50%)]"
              }`}
            >
              {s.name}
            </button>
          ))}
        </div>

        {/* Light level bars */}
        <div className="mt-6 flex items-end gap-3">
          {scene.levels.map((level, i) => (
            <div key={i} className="flex flex-1 flex-col items-center gap-2">
              <div className="relative h-24 w-full overflow-hidden rounded-sm bg-[hsl(0,0%,8%)]">
                <div
                  className="absolute bottom-0 w-full rounded-sm transition-all duration-[1.2s] ease-in-out"
                  style={{
                    height: `${level * 100}%`,
                    background: `linear-gradient(to top, hsl(40, 20%, ${15 + level * 40}%), hsl(40, 10%, ${8 + level * 20}%))`,
                    boxShadow: level > 0.3 ? `0 0 ${level * 20}px hsl(40, 20%, ${20 + level * 15}%)` : "none",
                  }}
                />
              </div>
              <span className="font-sans text-[9px] text-[hsl(0,0%,30%)]">
                {Math.round(level * 100)}
              </span>
            </div>
          ))}
        </div>

        {/* Active scene label */}
        <div className="mt-5 flex items-center justify-between">
          <span className="font-sans text-[10px] uppercase tracking-[0.2em] text-[hsl(0,0%,35%)]">
            Active Scene
          </span>
          <span className="font-sans text-xs text-[hsl(40,25%,70%)] transition-all duration-700">
            {scene.name}
          </span>
        </div>
      </div>
    </div>
  );
}
